import Home from "./pages/Home"

//? Component
function App() {
  //? JS kodu
  

  return (
    //! JSX (HTML- JS'nin birleşmiş hali)
    <Home/>
  )
}

export default App



